
// initial   → starting state (before visible)
// animate   → final visible state
// exit      → state when leaving/unmounting
// transition→ how fast and smooth the movement is
// Negative → move UP
// Positive → move DOWN
// SPEED → 0.2 → very fast
// SPEED → 0.35 → normal
// SPEED → 0.6 → slow
// SPEED → 1 → dramatic
// EASE :LINEAR- CONSTANT SPEED
// EASE :EASEIN- SLOW START, FAST END
// EASE :EASEOUT- FAST START, SLOW END
// EASE :EASEINOUT- SLOW START, FAST MIDDLE, SLOW END
export const animations = {
slideFromTop: {
  initial: {
    opacity: 0,
    y: -400,
    scale: 2,
  },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
  },
  exit: {
    opacity: 0,
    y: 400,
    scale: 1,
  },
  transition: {
    duration: 0.35,
    ease: "easeInOut",
  }
},
  slideFromLeft: {
    initial: {
      opacity: 0,
      x: -150,
    },
    animate: {
      opacity: 1,
      x: 0,
    },
    exit: {
      opacity: 0,
      x: 150,
    },
    transition: {
      duration: 0.35,
      ease: 'easeInOut',
    },
  },

  slideFromRight: {
    initial: { opacity: 0, x: 80 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -80 },
    transition: {
      duration: 0.35,
      ease: 'easeInOut',
    },
  },

  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: {
      duration: 0.3,
    },
  },

  zoom: {
    initial: {
      opacity: 0,
      scale: 0.95,
    },
    animate: {
      opacity: 1,
      scale: 1,
    },
    exit: {
      opacity: 0,
      scale: 0.95,
    },
    transition: {
      duration: 0.3,
      ease: 'easeOut',
    },
  },

  flip: {
    initial: {
      opacity: 0,
      rotateX: -90,
    },
    animate: {
      opacity: 1,
      rotateX: 0,
    },
    exit: {
      opacity: 0,
      rotateX: 90,
    },
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
    },
  },

  slideZoom: {
    initial: {
      opacity: 0,
      y: -30,
      scale: 0.98,
    },
    animate: {
      opacity: 1,
      y: 0,
      scale: 1,
    },
    exit: {
      opacity: 0,
      y: 30,
      scale: 0.98,
    },
    transition: {
      duration: 0.35,
      ease: 'easeOut',
    },
  },
};
